import { DbCrudHelper, RowsAffected } from "@app/shared/services/db-crud-helper";
import { Municipality, MunicipalityData, MunicipalityHelper } from "../model/municipality";

import { Injectable } from "@angular/core";
import { ClareWSCrudHelperService } from "@app/shared/services/clare-ws-crud-helper.service";
import { TSLoggingService } from "@app/shared/services/ts-logging.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

export type CreateMunicipalityPayload = Omit<Municipality, "id">;

@Injectable({
    providedIn: "root",
})
export class MunicipalityDbService {
    private helper = new MunicipalityHelper();
    crudHelperService: ClareWSCrudHelperService<Municipality, MunicipalityData>;

    constructor(tsLoggingService: TSLoggingService, crudHelper: DbCrudHelper) {
        this.crudHelperService = new ClareWSCrudHelperService(tsLoggingService, crudHelper, this.helper);
    }

    getProjectMunicipalities(projectId: number): Observable<Municipality | null> {
        return this.crudHelperService
            .retrieveSingle({
                endpoint: "GetProjectMunicipality",
                data: { id: projectId },
            })
            .pipe(
                map(data => {
                    if (data) {
                        return MunicipalityHelper.fromDbObject(data);
                    }

                    return null;
                })
            );
    }

    create(municipality: Municipality): Observable<Municipality> {
        return this.crudHelperService
            .create({
                endpoint: "CreateMunicipality",
                data: municipality,
                logData: { municipality },
            })
            .pipe(map(data => MunicipalityHelper.fromDbObject(data)));
    }

    update(municipality: Municipality): Observable<RowsAffected> {
        return this.crudHelperService.update({
            endpoint: "UpdateMunicipality",
            data: municipality,
            logData: { municipality },
        });
    }
}
